module.exports = __webpack_public_path__ + "img/graph-up.7e876eb3.svg";